export const WEB_URL = "https://careerbigbro.com/";
export const API_URL = "https://careerbigbro.com/api/";

//export const WEB_URL = "http://localhost:3000/";
//export const API_URL = "http://localhost:90/career/";

export const ASSETS_PATH = '';
export const GOOGLE_LOGIN_BTN_CLIENT_ID = '208665235149-pmag03n5f5p5m4qclrkcuaqvrtd842fu.apps.googleusercontent.com';
export const FACEBOOK_LOGIN_APP_ID = "1902715450568984";